import selfHtml from './s912-new_priv_key.html' with { type: 'text' };;


import { show_modal, update_username, form_validate, redirect_terms_and_conditions } from "../utils.js";

import { generate_key, get_pub_key, add_pub_key, gpg_import_keypair } from "../crypt_helper.js";

import { db_PrivateKeyPair } from "../AppState.js";

var root

export async function init(module_root) {

    module_root.innerHTML = selfHtml;
    root = module_root;


    const colors = ["Amber", "Amethyst", "Apricot", "Azure", "Beige", "Black", "Blue", "Bronze", "Brown", "Cerulean", "Copper",
        "Coral", "Crimson", "Cyan", "Emerald", "Fuchsia", "Gold", "Gray", "Green", "Indigo", "Ivory", "Khaki", "Lavender", "Lime",
        "Magenta", "Maroon", "Mint", "Mustard", "Navy", "Ochre", "Olive", "Orange", "Peach", "Pearl", "Pink", "Plum", "Purple",
        "Red", "Rose", "Ruby", "Silver", "Tangerine", "Teal", "Topaz", "Turquoise", "Violet", "White", "Yellow", "Agile", "Attentive",
        "Brave", "Bright", "Bubbly", "Clever", "Humble", "Majestic", "Mellow", "Nimble", "Quick", "Radiant", "Resilient", "Sleek",
        "Smart", "Vibrant", "Wise", "Zippy", "Alpha", "Beta", "Gamma", "Delta", "Zeta", "Eta", "Theta", "Iota", "Kappa", "Lambda",
        "Omicron", "Sigma", "Omega"]

    const animals = ["Albatross", "Alpaca", "Antelope", "Armadillo", "Badger", "Beaver", "Bison", "Buffalo", "Capybara",
        "Caracal", "Cassowary", "Cheetah", "Coyote", "Crocodile", "Deer", "Dolphin", "Dragon", "Eagle", "Elephant", "Emu", "Falcon",
        "Flamingo", "Fox", "Gazelle", "Gecko", "Giraffe", "Grizzly Bear", "Hawk", "Heron", "Hippopotamus", "Iguana",
        "Jaguar", "Kangaroo", "Koala", "Leopard", "Lion", "Llama", "Lynx", "Manatee", "Manta Ray", "Meerkat", "Mongoose", "Moose",
        "Ocelot", "Octopus", "Okapi", "Ostrich", "Otter", "Panda", "Parrot", "Peacock", "Pelican", "Penguin",
        "Polar Bear", "Porcupine", "Pufferfish", "Quokka", "Rabbit", "Rhinoceros", "Robin", "Sea Lion", "Sea Turtle", "Seagull", "Shark",
        "Sloth", "Squirrel", "Stingray", "Swordfish", "Tapir", "Tiger", "Tortoise", "Walrus", "Whale", "Wolf", "Wolverine", "Woodpecker",
        "Zebra", "Gold", "Silver", "Platinum", "Palladium", "Rhodium", "Iridium", "Osmium", "Ruthenium", "Copper", "Bronze",
        "Brass", "Titanium", "Aluminum", "Nickel", "Cobalt", "Zinc", "Tin", "Chromium", "Magnesium", "Tungsten", "Molybdenum",
        "Vanadium", "Niobium", "Tantalum", "Gallium", "Indium", "Scandium", "Yttrium", "Zirconium",
        "Diamond", "Ruby", "Sapphire", "Emerald", "Alexandrite", "Tanzanite", "Topaz", "Amethyst", "Aquamarine", "Garnet", "Peridot",
        "Spinel", "Zircon", "Morganite", "Citrine", "Prasiolite", "Moonstone", "Sunstone", "Labradorite", "Amazonite", "Orthoclase",
        "Agate", "Moss Agate", "Fire Agate", "Onyx", "Carnelian", "Sardonyx", "Chrysoprase", "Bloodstone", "Jasper", "Picture Jasper",
        "Aragonite", "Pearl", "Coral", "Jet", "Copal", "Larimar", "Sugilite", "Charoite", "Pietersite", "Seraphinite", "Moldavite",
        "Turquoise", "Lapis Lazuli", "Chrysocolla", "Kyanite", "Apatite", "Fluorite", "Marble", "Slate", "Soapstone", "Serpentine", "Schist", "Gneiss",
        "Obsidian", "Pumice", "Basalt", "Andesite", "Granite", "Sandstone", "Limestone", "Travertine", "Dolomite", "Flint", "Chert",
        "Opal", "Calcite", "Rhodochrosite", "Malachite"]


    $("new_priv_name").value = colors[Math.floor(Math.random() * (colors.length))]
        + " " + animals[Math.floor(Math.random() * (animals.length))];

    form_validate(root, async (event) => {
        await genPrivKey()
        const oc = event.target.closest(".offcanvas");
        const offcanvas = await bootstrap.Offcanvas.getOrCreateInstance(oc);
        offcanvas.hide();
        update_username()
    });

    setTimeout(() => {
        $('new_priv_name').select();
    }, 100);

    root.querySelector(".btn_gen_new_keypair").addEventListener('click', (e) => { open_gen_new_keypair() });

    root.querySelector(".open_import_keypair_file").addEventListener('click', () => open_import_keypair_file());

    root.querySelector(".open_import_keypair_qr").addEventListener('click', () => open_import_keypair_qr());

    root.querySelector(".import_keypair").addEventListener('click', (e) => { import_keypair(e) });

    root.querySelector(".redirect_terms_and_conditions").addEventListener('click', (e) => { redirect_terms_and_conditions(e) });

    root.querySelector("#check_terms_and_conditions").addEventListener('change', (e) => {
        root.querySelector(".open_import_keypair_file").disabled = !e.target.checked
        root.querySelector(".btn_gen_new_keypair").disabled = !e.target.checked
    })


}

// -------------------------------------------------------------------------------------------

async function genPrivKey() {

    const name = $("new_priv_name").value
    const email = $("new_priv_email").value
    const comment = $("new_priv_comment").value
    const passphrase = crypto.randomUUID();

    try {

        await generate_key(name, email, comment, passphrase)

    }
    catch (err) {
        show_modal('Error', err + ". Check the email format")
        console.log(err);
    }

}

// -------------------------------------------------------------------------------------------

async function import_keypair(event) {
    try {

        const privateKeyArmored = $('import_pgp_private').value; // `-----BEGIN PGP PUBLIC KEY BLOCK-----
        const publicKeyArmored = $('import_pgp_public').value; //`-----BEGIN PGP PRIVATE KEY BLOCK-----
        const passphrase = $('import_pgp_passphrase').value;  // what the private key is encrypted with

        gpg_import_keypair(privateKeyArmored, publicKeyArmored, passphrase);

        const oc = event.target.closest(".offcanvas");
        const offcanvas = await bootstrap.Offcanvas.getOrCreateInstance(oc);
        offcanvas.hide();
        update_username();

    } catch (err) {
        console.log(err);
        show_modal("Invalid key", err.message);
    }

}

// -------------------------------------------------------------------------------------------
function open_gen_new_keypair() {
    root.querySelector(".coll_card_welcome_keys").classList.remove("show")
    root.querySelector(".coll_gen_new_keypair").classList.add("show")
    root.querySelector(".coll_card_import_keys").classList.remove("show")
    document.querySelector("#new_priv_name").focus();
}
// -------------------------------------------------------------------------------------------
function open_import_keypair_file() {
    root.querySelector(".coll_card_welcome_keys").classList.remove("show")
    root.querySelector(".coll_gen_new_keypair").classList.remove("show")
    root.querySelector(".coll_card_import_keys").classList.add("show")
}
// -------------------------------------------------------------------------------------------
function open_import_keypair_qr() {
    show_modal("Link Device", "In your existing account, open the menu 'Link device QR' and follow the instructions to import a key pair from another device.");
}
